export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14996.6a35deb5.jpg";